export const environment = {
  production: true,
  environmentName: 'production',
  useWebSocket: true,
  authTokenKey: 'ce4d54234342343_token',
  backendEndpoint: 'https://wl-api-live.quickbus.com/api/v1/',
  rollbarKey: '884e3ed170344ae0ac3e0c7e4f9ce215',
  VAPID_PUBLIC_KEY: 'BJhPl1rWmJcYx33WbAf9fcYfn10x73iBzOXUzFWc1iolPkK2rjpo821fm7j65v8UDGi8oPPA2sWQffZXiFXnRok',
  S3_ASSETS_BASE: 'https://qb-whitelabel.s3.af-south-1.amazonaws.com/',
  S3_MEDIA_BASE: 'https://s3.eu-west-3.amazonaws.com/media.quickbus.com/',
  mainEndpoint: 'https://live.api.quickbus.com/v2/',
  siteUnderConstructionUrl: 'https://qb-whitelabel.s3.af-south-1.amazonaws.com/under-construction-prod.json',
  updateDate: 'https://qb-whitelabel.s3.af-south-1.amazonaws.com/last-forced-cache-update.json',
  flightsUrl:'https://itinerary.buupass.com/',
  itinerary_client_id:'eVCYpbJSuzv1njmh72tVIVU4JVf5ZFH6',
  itinerary_client_secret_key:'lQVCRPl8mMUGyASQtRhvIYp02OFGZPIF',
  itinerary_justgo_client_id:'W3P1VQG52JiYnAatbtsZMfq3FfS07sSd',
  itinerary_justgo_client_secret_key:'2LcYhojuh3dRaETPhkErRU9aaNBF9yDa',
  socketUrl: 'wss://itinerary.buupass.com/v2/schedules/flights',
  getTokenCred: 'https://itinerary.buupass.com/token/',
  flightsPaymentEndpoint: 'https://payment.quickbus.com/makepayment/flights',
  promotionsBaseUrl: 'https://promotions.buupass.com',
  moengageAppId: 'JAPTDZ3Z41ZAAI094A9KRBS1',
  moengageAppIdQuickbus: '1GHQ8MNLDZE8GX2IS95VZU04'
};
